export const escrowABI = [
    {
        payable: false,
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'trustedIssuer', internalType: 'address', type: 'address', indexed: true }],
        name: 'DefaultTrustedIssuerAdded',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'trustedIssuer', internalType: 'address', type: 'address', indexed: true }],
        name: 'DefaultTrustedIssuerRemoved',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'previousOwner', internalType: 'address', type: 'address', indexed: true },
            { name: 'newOwner', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OwnershipTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'by', internalType: 'address', type: 'address', indexed: true },
            { name: 'token', internalType: 'address', type: 'address', indexed: true },
            { name: 'value', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'paymentId', internalType: 'address', type: 'address', indexed: false },
        ],
        name: 'Revocation',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'from', internalType: 'address', type: 'address', indexed: true },
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'token', internalType: 'address', type: 'address', indexed: true },
            { name: 'value', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'paymentId', internalType: 'address', type: 'address', indexed: false },
            { name: 'minAttestations', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'Transfer',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'paymentId', internalType: 'address', type: 'address', indexed: true },
            { name: 'trustedIssuers', internalType: 'address[]', type: 'address[]', indexed: false },
        ],
        name: 'TrustedIssuersSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'paymentId', internalType: 'address', type: 'address', indexed: true }],
        name: 'TrustedIssuersUnset',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'to', internalType: 'address', type: 'address', indexed: true },
            { name: 'token', internalType: 'address', type: 'address', indexed: true },
            { name: 'value', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'paymentId', internalType: 'address', type: 'address', indexed: false },
        ],
        name: 'Withdrawal',
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'MAX_TRUSTED_ISSUERS_PER_PAYMENT',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
        name: 'defaultTrustedIssuers',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'escrowedPayments',
        outputs: [
            { name: 'recipientIdentifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'sender', internalType: 'address', type: 'address' },
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'value', internalType: 'uint256', type: 'uint256' },
            { name: 'sentIndex', internalType: 'uint256', type: 'uint256' },
            { name: 'receivedIndex', internalType: 'uint256', type: 'uint256' },
            { name: 'timestamp', internalType: 'uint256', type: 'uint256' },
            { name: 'expirySeconds', internalType: 'uint256', type: 'uint256' },
            { name: 'minAttestations', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'isOwner',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'owner',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: '', internalType: 'bytes32', type: 'bytes32' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'receivedPaymentIds',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'registry',
        outputs: [{ name: '', internalType: 'contract IRegistry', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'registryContract',
        outputs: [{ name: '', internalType: 'contract IRegistry', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: '', internalType: 'address', type: 'address' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'sentPaymentIds',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: '', internalType: 'address', type: 'address' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'trustedIssuersPerPayment',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'initialize',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'trustedIssuer', internalType: 'address', type: 'address' }],
        name: 'addDefaultTrustedIssuer',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'trustedIssuer', internalType: 'address', type: 'address' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'removeDefaultTrustedIssuer',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'value', internalType: 'uint256', type: 'uint256' },
            { name: 'expirySeconds', internalType: 'uint256', type: 'uint256' },
            { name: 'paymentId', internalType: 'address', type: 'address' },
            { name: 'minAttestations', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'transfer',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'value', internalType: 'uint256', type: 'uint256' },
            { name: 'expirySeconds', internalType: 'uint256', type: 'uint256' },
            { name: 'paymentId', internalType: 'address', type: 'address' },
            { name: 'minAttestations', internalType: 'uint256', type: 'uint256' },
            { name: 'trustedIssuers', internalType: 'address[]', type: 'address[]' },
        ],
        name: 'transferWithTrustedIssuers',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'paymentId', internalType: 'address', type: 'address' },
            { name: 'v', internalType: 'uint8', type: 'uint8' },
            { name: 'r', internalType: 'bytes32', type: 'bytes32' },
            { name: 's', internalType: 'bytes32', type: 'bytes32' },
        ],
        name: 'withdraw',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'paymentId', internalType: 'address', type: 'address' }],
        name: 'revoke',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'identifier', internalType: 'bytes32', type: 'bytes32' }],
        name: 'getReceivedPaymentIds',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
        name: 'getSentPaymentIds',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'paymentId', internalType: 'address', type: 'address' }],
        name: 'getTrustedIssuersPerPayment',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'pure',
        type: 'function',
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getDefaultTrustedIssuers',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
];
